<template>
	<div>
		<a class="scroll-down scroll-down-sub smooth-scroll show" @click="scrollDown()">
			<div class="to-top-icon" />
		</a>

		<a class="to-top" @click="scrollUp()">
			<div class="to-top-icon" />
		</a>
	</div>
</template>

<script setup>
const scrollUp = () => {
	smoothScrollTo(0, 1400);
};

const scrollDown = () => {
	smoothScrollTo(window.innerHeight, 800);
};

const handleScroll = () => {
	const scrollUp = document.querySelectorAll('.to-top');
	const scrollDown = document.querySelectorAll('.scroll-down');
	if (window.pageYOffset >= 350) {
		scrollUp.forEach((el) => el.classList.add('show'));
		scrollDown.forEach((el) => el.classList.remove('show'));
	} else {
		scrollUp.forEach((el) => el.classList.remove('show'));
		scrollDown.forEach((el) => el.classList.add('show'));
	}
};

onBeforeMount(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});

function smoothScrollTo(targetPosition, duration) {
	const startPosition = window.scrollY;
	const distance = targetPosition - startPosition;
	let startTime = null;

	function animation(currentTime) {
		if (startTime === null) {
			startTime = currentTime;
		}
		const timeElapsed = currentTime - startTime;

		// Ease-in-out function for smoother scrolling
		const ease = (t) => t * (2 - t);

		// prettier-ignore
		const run = (ease(Math.min(timeElapsed / duration, 1)) * distance) + startPosition;
		window.scrollTo(0, run);

		if (timeElapsed < duration) {
			requestAnimationFrame(animation);
		}
	}

	requestAnimationFrame(animation);
}
</script>

<style lang="scss" scoped>
.to-top,
.scroll-down {
	position: fixed;
	bottom: 60px;
	right: 20px;
	opacity: 0;
	cursor: pointer;
	transition: opacity 0.5s ease-in-out;
	z-index: -1;

	&.show {
		opacity: 1;
		z-index: 99;
	}

	&:hover {
		transform: scale(1.05);
	}

	.to-top-icon {
		background: url('~/assets/images/icon-to-top.svg') no-repeat center center;
		width: 20px;
		height: 31px;
		background-size: 20px;
	}
}

.scroll-down {
	.to-top-icon {
		transform: rotate(180deg);
	}
}

@media (max-width: 600px) {
	.to-top {
		bottom: 20px;
		right: 7px;
	}
}
</style>
